import http from "../http-common";

class AccountDataService {
    getAll() {
        return http.get("/accounts", {
            withCredentials: true
        });
    }

    create(data) {
        return http.post("/accounts", data, {
            withCredentials: true
        });
    }

    get(id) {
        return http.get(`/accounts/${id}`, {
            withCredentials: true
        });
    }

    update(id, data) {
        return http.put(`/accounts/${id}`, data, {
            withCredentials: true
        });
    }

    delete(id) {
        return http.delete(`/accounts/${id}`, {
            withCredentials: true
        });
    }

    findByName(name) {
        return http.get(`/accounts?name=${name}`, {
            withCredentials: true
        });
    }

    // // Returns the bool value of if user wants to get emails or not
    // getEmailsStatus(user_id) {
    //     return http.get(`/accounts/${user_id}/emailStatus`, {headers: {Authorization: 'Bearer ' + token}});
    // }

    // // changes  disabling or enabling of emails based on user setting for email status for hardware tickets 
    // changeEmailsStatus(user_id, data) {
    //     return http.put(`/accounts/${user_id}/updateEmailStatus`, data, {headers: {Authorization: 'Bearer ' + token}});
    // }

    // // changes  disabling or enabling of emails based on user setting for email status for software tickets 
    // changeSoftwareEmailsStatus(user_id, data) {
    //     return http.put(`/accounts/${user_id}/updateSoftwareEmailStatus`, data, {headers: {Authorization: 'Bearer ' + token}});
    // }
}


export default new AccountDataService();